var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkpoint-prep-note-field"},[(_vm.prose)?_c(_setup.CheckpointPrepNoteBlock,{attrs:{"note":_vm.note}}):_c(_setup.CheckpointPrepNoteInput,{attrs:{"model-value":_vm.note,"readonly":_vm.readonly},on:{"update:modelValue":function($event){return _vm.$emit('update:note', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }